import { notification } from 'antd';

const AppNotification = (message, type) => {
  notification[type]({
    message: message,
  });
};
export default AppNotification;
